import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePenghasilanLamp1771ivs = new CrudCustom('/tipe-penghasilan-lamp-1771-is');
export default TipePenghasilanLamp1771ivs;
